import styled from 'styled-components';
import React from 'react';
import Titleraison from './titre';
import Rectangleraison from './rectangle_text';


const Containerraison = styled.div`
  min-height:  100vh;
`;

const Raison = () => {
    return (
      <Containerraison>
          <Titleraison/>
          <Rectangleraison/>
      </Containerraison>
    );
};

export default Raison;